import { AbstractControl } from '@angular/forms';

export function validateDate(c: AbstractControl) {
    let DATE_REGEX = /^(\d{1,2}(\/|-|.)){2}\d{4}$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return (c.value == null || c.value == '' || DATE_REGEX.test(c.value) ? null : {
        validateDate: {
            valid: false
        }
    });
}